<div class='t-table__item__wrapCeil__ceilRow' ceilTable [idxCeil]='0'>
  <meSvg *ngIf='deviceS.isDesktop && !item.hiddenChx && !hiddenChx'
         [svgName]='item.isSelect|getChxSvgName' class='t-table__item__wrapCeil__ceilRow__chx'
         (click)='meTableS.selectItem(item)' stopPropagation></meSvg>

  <div *ngIf='text' class='t-fontBold o-noWrap'>{{ text }}</div>

  <meSvg *ngIf='matTooltip_canceledDetails' svgName='question_red&20' [matTooltip]='matTooltip_canceledDetails'
         class='o-mg-l-5' matTooltipClass='matTooltipRed'></meSvg>
</div>